import SummaryComponent from './SummaryComponent';

export default SummaryComponent;
